import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';

const navLinks = [
  { to: '/about', label: 'About Us' },
  { to: '/initiatives', label: 'Initiatives' },
  { to: '/events', label: 'Events' },
  { to: '/get-involved', label: 'Get Involved' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact' },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-red-700 shadow-lg shadow-red-900/20' : 'bg-red-600'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <Link to="/" onClick={() => setIsOpen(false)}
            className="flex items-center gap-3 group flex-shrink-0">
            <img src="/assets/logo.jpg" alt="Khisa Foundation"
              className="h-10 w-10 rounded-full object-cover ring-2 ring-white/25 group-hover:ring-white/50 transition-all duration-300" />
            <div className="hidden sm:block leading-tight">
              <p className="text-white font-bold text-sm tracking-tight">Khisa Foundation</p>
              <p className="text-red-200 text-[11px] font-normal">for Impact and Empowerment</p>
            </div>
            <span className="text-white font-bold text-base sm:hidden">KFIE</span>
          </Link>

          {/* Desktop navigation */}
          <div className="hidden md:flex items-center gap-0.5">
            {navLinks.map(({ to, label }) => (
              <NavLink key={to} to={to}
                className={({ isActive }) =>
                  `relative px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'text-white bg-white/15'
                      : 'text-red-100 hover:text-white hover:bg-white/10'
                  }`
                }>
                {label}
              </NavLink>
            ))}
            <Link to="/donate"
              className="ml-3 bg-white text-red-600 hover:bg-red-50 px-5 py-2 rounded-full text-sm font-bold transition-all duration-200 shadow-sm hover:shadow-md">
              Donate
            </Link>
          </div>

          {/* Hamburger */}
          <button onClick={() => setIsOpen((v) => !v)}
            className="md:hidden flex flex-col justify-center items-center w-10 h-10 rounded-lg hover:bg-white/10 transition-colors gap-1.5"
            aria-label="Toggle menu">
            <span className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 origin-center ${isOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 ${isOpen ? 'opacity-0 scale-x-0' : ''}`} />
            <span className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 origin-center ${isOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="border-t border-red-500/40 px-4 py-3 space-y-1">
          {navLinks.map(({ to, label }) => (
            <NavLink key={to} to={to} onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive ? 'bg-white/15 text-white' : 'text-red-100 hover:bg-white/10 hover:text-white'
                }`
              }>
              {label}
            </NavLink>
          ))}
          <Link to="/donate" onClick={() => setIsOpen(false)}
            className="block mt-2 bg-white text-red-600 text-center px-4 py-2.5 rounded-full text-sm font-bold">
            Donate Now
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
